<form
  [formGroup]="form"
  (ngSubmit)="submit()"
  class="gw-flex gw-flex-col gw-gap-6 gw-p-1"
>
  <div
    *ngIf="noRoutingTargets"
    class="gw-rounded-lg gw-border gw-border-status-warning gw-bg-status-warning-pale gw-p-3 gw-text-sm gw-text-text-primary"
    role="alert"
  >
    {{
      'features.wallets.integrationRouting.noRoutableIntegrations' | translate
    }}
  </div>

  <gatewee-select-v3
    formControlName="targetIntegrationId"
    [label]="
      'features.wallets.integrationRouting.form.targetIntegration' | translate
    "
    [placeholder]="
      'features.wallets.integrationRouting.form.selectTarget' | translate
    "
    [items]="targetIntegrationItems"
    [required]="true"
    [customMessages]="targetIntegrationSelectErrorMessages"
  ></gatewee-select-v3>

  <gatewee-select-v3
    formControlName="paymentMethod"
    [label]="
      'features.wallets.integrationRouting.form.paymentMethod' | translate
    "
    [placeholder]="
      'features.wallets.integrationRouting.form.anyMethod' | translate
    "
    [items]="paymentMethodItems"
  ></gatewee-select-v3>

  <div class="gw-flex gw-flex-col gw-gap-2">
    <div class="gw-grid gw-grid-cols-2 gw-gap-4">
      <gatewee-input-v2
        [form]="form"
        controlName="minAmount"
        type="number"
        label="features.wallets.integrationRouting.form.minAmount"
        id="integration-routing-rule-min-amount"
        [min]="0"
      ></gatewee-input-v2>
      <gatewee-input-v2
        [form]="form"
        controlName="maxAmount"
        type="number"
        label="features.wallets.integrationRouting.form.maxAmount"
        id="integration-routing-rule-max-amount"
        [min]="0"
      ></gatewee-input-v2>
    </div>
    <p
      *ngIf="amountRangeError()"
      class="gw-text-xs gw-text-status-negative gw-m-0"
    >
      {{ 'features.wallets.integrationRouting.errors.minMaxRange' | translate }}
    </p>
  </div>

  <gatewee-input-v2
    [form]="form"
    controlName="priority"
    type="number"
    label="features.wallets.integrationRouting.form.priority"
    id="integration-routing-rule-priority"
    [required]="true"
  ></gatewee-input-v2>

  <gatewee-input-v2
    [form]="form"
    controlName="description"
    label="features.wallets.integrationRouting.form.description"
    id="integration-routing-rule-description"
  ></gatewee-input-v2>

  <label
    *ngIf="isEdit"
    class="gw-flex gw-items-center gw-gap-2 gw-cursor-pointer"
  >
    <input tuiCheckbox type="checkbox" formControlName="isActive" size="m" />
    <span class="gw-text-sm gw-text-text-primary">{{
      'features.wallets.integrationRouting.form.isActive' | translate
    }}</span>
  </label>

  <div
    class="gw-flex gw-justify-end gw-gap-3 gw-pt-4 gw-mt-2 gw-border-t gw-border-border-normal"
  >
    <gatewee-button
      variant="outline"
      type="button"
      size="m"
      [title]="'common.actions.cancel' | translate"
      (clicked)="cancel()"
    ></gatewee-button>
    <gatewee-button
      variant="primary"
      type="submit"
      size="m"
      [disabled]="noRoutingTargets"
      [title]="'common.actions.save' | translate"
    ></gatewee-button>
  </div>
</form>
